import classes from "./ErrorMsg.module.css";

export function ErrorMsg({ msg }) {
  return (
    <div className={classes.container}>
      <h4>{msg}</h4>
    </div>
  );
}
